export default "__VITE_PUBLIC_ASSET__85414eaf__"